import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '../../../../store/store';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import FilledQuestionnaireList from './FilledQuestionnaireList';

loadDOMComponent({
	selector: 'react-filled-questionnaire-list',
	callback: ({ container, context }: any) => {
		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<FilledQuestionnaireList />
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
